<div class="flex-wrapper">
  <div class="center-page">
    <section id="result">
      <header>
        <h1>
          {{ 'rspResultHeading' | translate }}
          @if (insuredPersonFullName) {
            <br />
            {{ 'rspInsuredPersonText' | translate: { insuredPersonName: insuredPersonFullName } }}
          }
        </h1>
      </header>
      @if (showResultToUser) {
        <div>
          @for (result of productResults; track result) {
            <div class="result-item">
              <section class="card">
                <header class="card-header">
                  <h5 class="result-name card-title">
                    {{ result.name }}
                  </h5>
                </header>
                <section class="card-body">
                  @for (rating of result.ratings; track rating) {
                    <section class="rating-item well-sm" [class]="'decision-' + rating.id">
                      <h6 class="rating-caption">{{ rating.caption }}</h6>
                      @if (rating.attributes?.length > 0 && rating.id !== 'Accept' && showDetails(rating.attributes)) {
                        <div class="rating-details">
                          <div class="well">
                            <h6 class="card-subtitle">
                              {{ 'rspResultHeadingDecisionDetails' | translate }}
                            </h6>
                            <ul class="list-attributes">
                              @for (attribute of rating.attributes; track attribute) {
                                <div class="attribute-item">
                                  <!-- Text template -->
                                  @if (isTextValueOnlyTemplate(rating.attributes, attribute)) {
                                    <li class="text-attr" [class]="attribute.id">
                                      <em>{{ attribute.value }}</em>
                                    </li>
                                  }
                                  <!-- Text and caption template -->
                                  @if (isCaptionAndValueTemplate(rating.attributes, attribute)) {
                                    <li class="exclusion-attr" [class]="attribute.id">
                                      <em>{{ attribute.caption }}: </em>{{ attribute.value }}
                                    </li>
                                  }
                                  <!-- Percentage template-->
                                  @if (isPercentageLoadingTemplate(rating.attributes, attribute)) {
                                    <li class="loading-attr" [class]="attribute.id">
                                      <em>{{ attribute.caption }}: </em>{{ attribute.value }}&#37;
                                    </li>
                                  }
                                  <!-- Permil template-->
                                  @if (isPerMilleLoadingTemplate(rating.attributes, attribute)) {
                                    <li class="loading-permil-attr" [class]="attribute.id">
                                      <em>{{ attribute.caption }}: </em>{{ attribute.value }}&#x2030;
                                    </li>
                                  }
                                  <!-- Duration template -->
                                  @if (isDurationMonthTemplate(rating.attributes, attribute)) {
                                    <li class="postpone-duration-attr" [class]="attribute.id">
                                      <em>{{ attribute.caption }}: </em>{{ attribute.value }} {{ 'rspMonths' | translate }}
                                    </li>
                                  }
                                  <!-- FlatExtraLoading template -->
                                  @if (isFlatExtraLoadingWithDuration(rating.attributes, attribute)) {
                                    <li class="loading-duration-attr">
                                      <em>{{ getFlatExtraLoadingWithDurationCaption(rating.attributes) }}&#x2030;</em>
                                      -
                                      <em>{{ getFlatExtraLoadingWithDurationValue(rating.attributes) }} {{ 'rspMonths' | translate }}</em>
                                    </li>
                                  }
                                  <!-- ObjectStructure template -->
                                  @if (isObjectStructureTemplate(rating.attributes, attribute)) {
                                    <li>
                                      <em>{{ attribute.value.Clause }}</em>
                                      <ul class="list-attributes">
                                        @for (assessmentFactorName of attribute.value.AssessmentFactorNames; track assessmentFactorName) {
                                          <li>
                                            <em>{{ assessmentFactorName }}</em>
                                          </li>
                                        }
                                      </ul>
                                    </li>
                                  }
                                  <!-- ListStructure template -->
                                  @if (isListStructureTemplate(rating.attributes, attribute)) {
                                    <div>
                                      @for (attributeValueEntry of attribute.value; track attributeValueEntry) {
                                        <li>
                                          <em>{{ attributeValueEntry.Clause }}</em>
                                          <ul class="list-attributes">
                                            @for (
                                              assessmentFactorName of attributeValueEntry.AssessmentFactorNames;
                                              track assessmentFactorName
                                            ) {
                                              <li>
                                                <em>{{ assessmentFactorName }}</em>
                                              </li>
                                            }
                                          </ul>
                                        </li>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </ul>
                          </div>
                        </div>
                      }
                    </section>
                  }
                  @if (result.ratings.length > 0) {
                    <section class="decision-default well-sm bg-info">
                      <p>
                        {{ 'rspResultDecisionDefault' | translate }}
                      </p>
                    </section>
                  }
                </section>
              </section>
            </div>
          }
        </div>
      }
      @if (!showResultToUser) {
        <div class="result-info" [innerHtml]="'rspResultDefaultInformationText' | translate"></div>
      }
    </section>
    <div class="result-navigation d-flex justify-content-between">
      @if (showGoToInitialInformationPageButton) {
        <button id="back-btn" class="btn btn-secondary" (click)="goToInitialInformationPage()" type="button">
          {{ 'rspResultButtonBackToInitialInformation' | translate }}
        </button>
      }
      @if (documentCreationEnabled) {
        <a class="btn btn-primary float-end" href="{{ docUrl }}" download target="_blank" rel="noopener">
          {{ 'rspResultButtonDownloadPdf' | translate }}
        </a>
      }
    </div>
  </div>
</div>
